import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { IncidentStatus } from 'src/app/domain/incidentStatus.model';
import { IIncidentsStatusResponse } from 'src/app/interfaces/Responses/IIncidentsStatusResponse';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';
import { GridColumnsConfiguration, GridFilter } from '../../shared/grid/grid.component';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { ModalReportFormEditComponent } from './modal-report-form-edit/modal-report-form-edit.component';
import { promise } from 'protractor';
import { PropertiesTowers } from 'src/app/services/dashboards/propertiesTower.service';
import { MatSelect } from '@angular/material/select';
import { LoginService } from 'src/app/services/security/login.service';

@Component({
  selector: 'neoris-field-service-review',
  templateUrl: './field-service-review.component.html',
  styleUrls: ['./field-service-review.component.css']
})
export class FieldServiceReviewComponent implements OnInit {
  today = new Date();
  month = this.today.getUTCMonth();
  year = this.today.getUTCFullYear();
  day = this.today.getUTCDate()
  arrayDevicesIncidentsTypes:any[] = []
  arrayReportStatus: IncidentStatus[] = []
  public gFilter: GridFilter = undefined;
  arrayGirdFieldsReviewGridTemp: any[] = []
  arrayGirdFieldsReviewGrid: any[] = []
  private lang: string = '';
  private onLanChange: Subscription
  private onDataUpdateFieldServices:Subscription
  private onIsAllSitesSubscription:Subscription


  
  requestFieldService:any={}

  @ViewChild('selIncidentType') selIncidentType: MatSelect;
  @ViewChild('selStatus') selStatus: MatSelect;
  
  constructor(private controltowerservice:ControltowerService,
    private translate: TranslateService,
    private dialog: MatDialog,
    private propertiesService:PropertiesTowers,
    private securityService: LoginService) { 
   
  }

  public gridColumnsConfiguration: GridColumnsConfiguration = {
    IconValue: "StatusId",
    IconColumnName: "Status",
    hiddenColumnNames: ["SiteId","StatusId","FieldServicesId", "ROW_ID"],
    dateColumns: [
      {columnName: "ReportedDate"},
      {columnName: "ClosedDate"}
    ],
    cardColum: "ReportedDate",
    cardValues: [
      { place: 0, nombre: 'ReportedDate', isMainColumn: false },
      { place: 0, nombre: 'ReportedBy', isMainColumn: false },
      { place: 0, nombre: 'Status', isMainColumn: false },
      { place: 0, nombre: 'Site', isMainColumn: false },
      { place: 0, nombre: 'Reason', isMainColumn: false },
      { place: 0, nombre: 'AffecteddServices', isMainColumn: false },
      { place: 0, nombre: 'AdditionalInformation', isMainColumn: false },
      { place: 0, nombre: 'ClosedDate', isMainColumn: false },
      { place: 0, nombre: 'ClosedBy', isMainColumn: false },
      { place: 0, nombre: 'FieldServicesAgent', isMainColumn: false },
      { place: 0, nombre: 'AgentComments', isMainColumn: false }
    ],
    MultiIconColumns: [
      ],
    ActionColumn: {
      ColumnName: "",
      Actions: [
      ]
    }
  }

  filters = new UntypedFormGroup({
    incidentType: new UntypedFormControl(''),
    status: new UntypedFormControl(''),
    start: new UntypedFormControl(new Date(this.year,  this.month , this.day)),
    end: new UntypedFormControl(new Date(this.year,  this.month , this.day + 1))
  });

  async ngOnInit(): Promise<void> {
    const userName = JSON.parse(localStorage.getItem('ud'))[1].value
    const guid = JSON.parse(localStorage.getItem('guidSession'))
    const response = await this.securityService.login(userName,guid).toPromise()


    this.onDataUpdateFieldServices = this.propertiesService.updateFildsServiceConfirm.subscribe((value) =>{
     console.log('valor de fiel servicies update--->',value)
      if(value) {
        this.getCallFieldsDevicesReview()
       
      }
    })

    
    this.onLanChange = this.translate.onLangChange.subscribe(s => {
      console.log("idioma",s.lang)
      this.lang = s.lang != undefined ? s.lang : "en";
      this.getGenericAtrributeValue(this.lang)
      
    })

    if(this.lang == undefined || this.lang==''){
      this.getGenericAtrributeValue('en')
    }


    await this.getFilters()

    
    this.onIsAllSitesSubscription =this.propertiesService.IsSelectAllSites$.subscribe((value) =>{
      this.getCallFieldsDevicesReview()
      
    
    })
  }


  private async getFilters(){
    
    
      setTimeout(()=>{                          
         this.setDefaultFilters()   
    }, 2000);
     
    
    
  }

  
  openDialog(): void {

    
    this.dialog.open(ModalReportFormEditComponent,
      {
        restoreFocus: false,
        width: '800px',
        maxHeight: '95vh'
    });

    
  }

  async getCallFieldsDevicesReview(){
    this.requestFieldService.deviceIncidentTypesId = []
    this.requestFieldService.deviceStatus = []
    let checkedIncidentDeviceType: any[] = this.filters.get('incidentType').value
     let checkedIncidentsStatus: any[] = this.filters.get('status').value
    const startDate: Date = this.filters.get('start').value
    const endDate: Date = this.filters.get('end').value

    for(let i= 0;i<=checkedIncidentDeviceType.length - 1;i++){
      this.requestFieldService.deviceIncidentTypesId.push(checkedIncidentDeviceType[i].id)
    }

    for(let j=0;j<=checkedIncidentsStatus.length - 1;j++){
      this.requestFieldService.deviceStatus.push(checkedIncidentsStatus[j].id)
    }

    this.requestFieldService.local_code = this.lang == '' ? 'en' : this.lang
    this.requestFieldService.site = localStorage.getItem('site');
    this.requestFieldService.deviceStartDate = startDate
    this.requestFieldService.deviceEndDate = endDate

    console.log('datat enviada')
    console.log(JSON.stringify(this.requestFieldService))
    let success = await this.getFieldsDevicesReview(this.requestFieldService)
  


  }

  private async getFieldsDevicesReview(filters:any):Promise<boolean>{
    this.arrayGirdFieldsReviewGridTemp = []
    this.arrayGirdFieldsReviewGrid = []

    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getServiceDeviceReview(filters).subscribe(
        {
          next: (fieldDevice: any=[]) => {
            for(let i=0;i<= fieldDevice.length -1;i++){
             
              console.log(fieldDevice[i].site)
              let siteName = fieldDevice[i].site.name
              let siteId = fieldDevice[i].site.id
             
              fieldDevice[i].reportServices.forEach(childObj=> {
              

           
                this.arrayGirdFieldsReviewGridTemp.push({ReportedDate:this.formatDate(childObj.fieldServiceReport.created),ReportedBy:childObj.fieldServiceReport.reportedBy,Status:childObj.fieldServiceReport.status.code,Site:siteName,Reason:childObj.fieldServiceReport.reason.code,AffecteddServices:childObj.sourceDevice.name,SiteId:siteId,StatusId:childObj.fieldServiceReport.status.id,AdditionalInformation:childObj.fieldServiceReport.additionalInformation,ClosedDate:childObj.fieldServiceReport.closedDate,ClosedBy:childObj.fieldServiceReport.closedBy,
                FiledServicesAgent:childObj.fieldServiceReport.fieldServiceAgent,AgentComments:childObj.fieldServiceReport.agentComments,FieldServicesId:childObj.fieldServiceReport.id})
              })

            }
           
            console.log(this.arrayGirdFieldsReviewGridTemp)
            this.arrayGirdFieldsReviewGrid = this.arrayGirdFieldsReviewGridTemp
            
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });

  }
  

  private async getGenericAtrributeValue(localCode:string): Promise<boolean> {
   

    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getAttributeValue(localCode).subscribe(
        {
          next: (attribute: any={}) => {
            console.log('si entre----->',attribute)
            for(let i=0;i<= attribute.attributeTypes.length -1;i++){
              if(attribute.attributeTypes[i].id == 52){
                console.log('si entre----->')
                this.arrayReportStatus = attribute.attributeTypes[i].attributeValues

              }
              else if(attribute.attributeTypes[i].id == 51){
                  this.arrayDevicesIncidentsTypes = attribute.attributeTypes[i].attributeValues
  
                }
              
            

            }
           
            
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }



  private async setDefaultFilters(){
   
    if (this.arrayDevicesIncidentsTypes.length > 0) {
      
      console.log('obtener values select2--->',this.selIncidentType.options)
      this.selIncidentType.options.forEach(f => {
        

        f.select()
       
      })

     
      
    }


    if(this.arrayReportStatus.length > 0){
      console.log('obtener values select2--->',this.selStatus.options)
      this.selStatus.options.forEach(g => {
        

        g.select()
       
      })


    }




    await this.getCallFieldsDevicesReview()
  }


  
  public cellClick(obj: any) {
    console.log("cellClick", obj)
    console.log('elemento:',obj)

    localStorage.setItem('rowFieldServicesReview',JSON.stringify(obj))

  
    this.openDialog()
 
  }

  private formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }

  ngOnDestroy():void{

    this.onDataUpdateFieldServices.unsubscribe()
    this.onIsAllSitesSubscription.unsubscribe()
    
    
  }

}
